<div *ngIf="isLoading | async" class="overlay">
  <p-progressSpinner class="spinner" ariaLabel="loading" mode="indeterminate" />
</div>